.icon-action {
    &:not(:has(.icon-action-disabled)):hover {
        --color: var(--hovered-icon-color);
    }

    &-wrapper {
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1; // square
    }

    &-target-area {
        position: absolute;
        aspect-ratio: 1; // square

        &:focus-visible {
            outline: 1px solid var(--stroke-action-focused);
            border-radius: 50%;
        }
    }

    &-disabled {
        opacity: var(--disabled-opacity);
    }
}
